module.exports = __webpack_public_path__ + "static/media/sehajdeep_singh.e9b1adbf.jpg";